module.exports = __webpack_public_path__ + "img/DSCN2037.44703364.jpg";